// extracted by css-extract-rspack-plugin
export default {"contactDealer":"_7a639804","link":"_73cce77f","small":"_cf737380","medium":"_e1415b82","phoneIcon":"_3bf50c88","iconWrapper":"_90a40287","phoneIconWrapper":"_ec2ffe3b"};